import { gql } from '@apollo/client';

export const DELETE_FILE_BY_URL = gql`
  mutation DeleteFileByUrl($url: String!, $storeId: ID!) {
    deleteFileByUrl(url: $url, storeId: $storeId) {
      __typename
      ... on DeleteFileByUrlSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
